<template>
  <div class="header">
      <h1 class="logo" >
        <a class="hr101" href="/">
          <img src="../assets/logo.png">
        </a>
        <a class="help_logo" href="/">帮助中心</a>
      </h1>
      <div class="search_header">
        <slot></slot>
      </div>
  </div>
</template>
<script>
  export default {
    name: "headers",
    data() {
          return {
              // isHead: this.$store.state.isHeadTip,
          }
    },
    props: {

    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
.header {
  height: 32px;
  padding:9px 16px 10px;
  background: #FFFFFF;
  min-width: 1168px;
  // position: fixed;
  // top:0px;
  // left:0px;
  // right:0px;
  // z-index: 44;
  box-shadow: 0 2px 14px -4px rgba(37,37,46,0.20);
}
.logo{
  float: left;
  padding:4px 0 2px;
  height:25px;
  vertical-align: top;
}
.hr101{
  display: block;
  overflow: hidden;
  float: left;
  height:25px;
  margin-right:16px;
  img{
    width: 96px;
    height:25px;
    display: block;
  }
}
.help_logo{
  // padding:3px 0 2px;
  display: inline-block;
  vertical-align: top;
  height:26px;
  line-height: 26px;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #202428;
  letter-spacing: 0;
  line-height: 26px;
}
.search_header{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/headers.vue